import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import MonthlySavingCalculator from "@/pages/MonthlySavingCalculator";
import RetirementCalculator from "@/pages/RetirementCalculator";
import ChildEducationCalculator from "@/pages/ChildEducationCalculator";
import RetirementPlanningPage from "@/pages/RetirementPlanningPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import FAQPage from "@/pages/FAQPage";
import CompliancePage from "@/pages/CompliancePage";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<HomePage />} />
              <Route path="calculator/monthly-saving" element={<MonthlySavingCalculator />} />
              <Route path="calculator/retirement" element={<RetirementCalculator />} />
              <Route path="calculator/child-education" element={<ChildEducationCalculator />} />
              <Route path="retirement-planning" element={<RetirementPlanningPage />} />
              <Route path="about" element={<AboutPage />} />
              <Route path="contact" element={<ContactPage />} />
              <Route path="faq" element={<FAQPage />} />
              <Route path="compliance" element={<CompliancePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </div>
    </HelmetProvider>
  );
}

export default App;
